<template>
	<Transition name="locked">
		<div v-if="isLandscape && isPhone" class="orientation-lock" aria-live="assertive" role="alert">
			<div class="locked-content">
					<icon name="rotate" class="icon icon-full rotate-icon"/>
				<p class="locked-message">Please rotate your device to portrait mode</p>
			</div>
		</div>
	</Transition>
</template>

<script setup lang="ts">
import {ref, onMounted, onUnmounted} from 'vue'
import Icon from "./Icon.vue";

const isLandscape = ref(false)
const isPhone = ref(false)

// Check if device is phone. Dont need to lock orientation on tablet or desktop
const detectPhone = async () => {
	// Primary: User Agent Client Hints. mobile === true on phones, false on tablets + desktops
	if (navigator.userAgentData) {
		const hints = await navigator.userAgentData.getHighEntropyValues(['mobile'])
		return hints.mobile === true
	}
	
	// Fallback: UA string
	const ua = navigator.userAgent
	return /iPhone|Android.*Mobile|Mobile.*Android/i.test(ua)
}

const onOrientationChange = () => {
	const type = screen.orientation.type
	isLandscape.value = type === 'landscape-primary' || type === 'landscape-secondary'
}

onMounted(async() => {
	isPhone.value = await detectPhone()
	onOrientationChange()
	screen.orientation.addEventListener('change', onOrientationChange)
})

onUnmounted(() => {
	screen.orientation.removeEventListener('change', onOrientationChange)
})
</script>

<style scoped>
.orientation-lock {
	position: fixed;
	inset: 0;
	z-index: 9999;
	background: var(--color-overlay);
	backdrop-filter: blur(var(--blur-md));
	-webkit-backdrop-filter: blur(var(--blur-md));
	display: flex;
	align-items: center;
	justify-content: center;
}

.locked-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--spacing-md);
	text-align: center;
	padding: var(--spacing-lg);
}

.rotate-icon {
	height: 50dvh;
	animation: rotate-hint 3s ease-in-out infinite;
}

.locked-message {
	max-width: 66vw;
}

@keyframes rotate-hint {
	0%, 33% {
		transform: rotate(0deg);
	}
	53% {
		transform: rotate(90deg);
	}
	63% {
		transform: rotate(90deg);
	}
	100% {
		transform: rotate(0deg);
	}
}

/* Component-level Transition */
.locked-enter-active,
.locked-leave-active {
	transition: opacity 0.5s ease;
}

.locked-enter-from,
.locked-leave-to {
	opacity: 0;
}
</style>